// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1825
module["exports"] = {
  wide: ["Bazar", "Bazar ertəsi", "Çərşənbə axşamı", "Çərşənbə", "Cümə axşamı", "Cümə", "Şənbə"],
  wide_context: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
  abbr: ["Ba", "BE", "ÇA", "Çə", "CA", "Cü", "Şə"],
  abbr_context: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"]
};